<template>
  <div id="reportPage">
    <article class="report-card">
      <div class="title-wrapper mb-4">
        <header class="login-title">
          <a href="#" class="login-title" @click.prevent="goToHome">
            {{ pageTitle }}
          </a>
        </header>

        <UserMenu :roles="roles" :user-name="userName" />
      </div>

      <div class="profiles-wrapper">
        <div
          v-for="client in rows"
          :key="client.id"
          class="profile-card"
        >
          <div class="profile-header">
            <h2>{{ client.user }}</h2>

            <span
              class="status-badge"
              :class="client.active ? 'active' : 'inactive'"
            >
              <span class="dot"></span>
              {{ client.active ? 'Active' : 'Inactive' }}
            </span>
          </div>

          <div class="profile-body">
            <div class="profile-grid">
              <div class="profile-label">Role:</div>
              <div class="profile-value">{{ formatRoles(client.roles) || '-' }}</div>

              <div class="profile-label">Company:</div>
              <div class="profile-value">{{ client.company_name || '-' }}</div>

              <div class="profile-label">Owner:</div>
              <div class="profile-value">{{ client.owner_name || '-' }}</div>
              <div></div>
              <div></div>
              <div class="profile-label">Owner Phone:</div>
              <div class="profile-value">{{ client.owner_phone || '-' }}</div>

              <div class="profile-label">Contact Name:</div>
              <div class="profile-value">{{ client.contact_name || '-' }}</div>
              <div class="profile-label">Contact Phone:</div>
              <div class="profile-value">{{ client.contact_phone || '-' }}</div>

              <div class="profile-label">Email:</div>
              <div class="profile-value">{{ client.email || '-' }}</div>
              <div class="profile-label">SMS Enabled:</div>
              <div class="profile-value">
                <input
                  type="checkbox"
                  disabled
                  :checked="client.sms_enabled"
                />
              </div>

              <div class="profile-label">Created At:</div>
              <div class="profile-value">{{ client.created_at || '-' }}</div>
              <div></div>
              <div></div>

              <div class="profile-label">Transfer Numbers:</div>
              <div class="profile-value">
                <div class="transfer-numbers-wrapper">
                  <div
                    v-for="(num, index) in client.transfer_numbers"
                    :key="index"
                    class="transfer-number"
                  >
                    <span class="blue-dot"></span>{{ num }}
                  </div>
                </div>
              </div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>


<script>
import UserMenu from '@/components/UserMenu.vue'

export default {
  components: { UserMenu },
  data() {
    return {
      username: "",
      columns: [
        { key: "user", label: "USER #" },
        { key: "transfer_numbers", label: "TRANSFER NUMBER" },
        { key: "role", label: "ROLE" },
        { key: "company_name", label: "COMPANY NAME" },
        { key: "owner_name", label: "OWNER NAME" },
        { key: "contact_name", label: "CONTACT NAME" },
        { key: "contact_phone", label: "CONTACT PHONE" },
        { key: "email", label: "EMAIL" },
        { key: "sms_enabled", label: "SMS ENABLED" },
        { key: "created_at", label: "CREATED AT" }
      ],
      roleOptions: [],
      rows: [],
      roles: [],
      showCreateModal: false,
      editingCell: null,
      showEditModal: false,
      editingClient: null,
      editedRows: new Set(),
      openActionsId: null,
      newClient: {
        user: "",
        password: "",
        role: "",
        transfer_number: "",
        company_name: "",
        owner_name: "",
        owner_phone: "",
        contact_name: "",
        contact_phone: "",
        email: "",
        sms_enabled: false
      },
    };
  },
  computed: {
    pageTitle() {
    if (!Array.isArray(this.roles)) return 'DNQ REPORT';

    if (this.roles.includes('admin')) {
      return 'DNQ REPORT';
    }

    if (this.roles.includes('cross_sales_configurator')) {
      return 'CROSS SALES CONFIGURATOR';
    }

    if (this.roles.includes('customer')) {
      return 'CALLS';
    }

    return 'DNQ REPORT';
  },
  },
  mounted() {
    const token = localStorage.getItem('token');
    const username = localStorage.getItem('username');
    this.username = username;
    this.fetchClients();
    this.check_role();
    console.log("toke");
    console.log(token);
    console.log("username");
    console.log(username);
    if (!token) {
      window.location.href = '/login';
      return;
    }
    document.title = "profile";
  },
  methods: {
    async authorizedFetch(url, options = {}) {
      let token = localStorage.getItem("token");

      if (!options.headers) options.headers = {};
      options.headers["Authorization"] = `Bearer ${token}`;

      let response = await fetch(url, options);

      // Если токен истёк — пробуем рефреш
      if (response.status === 401) {
        const refresh_token = localStorage.getItem("refresh_token");
        if (!refresh_token) {
          this.logout();
          return;
        }

        // Запрос на рефреш токена
        const refreshRes = await this.authorizedFetch("/api/refresh", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ refresh_token })
        });

        if (!refreshRes.ok) {
          // Если рефреш не прошёл — редирект на логин
          this.logout();
          return;
        }

        const data = await refreshRes.json();
        token = data.token;
        localStorage.setItem("token", token);

        // Повторяем исходный запрос с новым токеном
        options.headers["Authorization"] = `Bearer ${token}`;
        response = await this.authorizedFetch(url, options);
      }

      return response;
    },
    goToHome() {
        if (this.roles.includes('admin')) {
            this.$router.push('/')
          } else if (this.roles.includes('customer')) {
            this.$router.push('/calls')
          } else if (this.roles.includes('cross_sales_configurator')) {
            this.$router.push('/Calls_quota')
          }
    },
    formatRoles(roles) {
      if (!roles) return '';
      if (Array.isArray(roles)) {
        return roles.join(', ');
      }
      return roles;
    },
    async check_role() {
      const token = localStorage.getItem('token');
      const username = localStorage.getItem('username');
      const params = new URLSearchParams({ user: username });

      const res = await fetch(`/api/role?${params.toString()}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      const data = await res.json();
      this.roles = data.roles;
      return this.roles;
    },
    async fetchClients() {
      const token = localStorage.getItem("token");
      const username = localStorage.getItem("username");
      try {
        const res = await this.authorizedFetch(`/api/clients?user=${encodeURIComponent(username)}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        });
        console.log(res);
        if (!res.ok) {
          localStorage.removeItem('token');
          localStorage.removeItem("username");
          window.location.href = '/login';
          return;
        }
        const data = await res.json();
        this.rows = data.items || [];
      } catch (error) {
        console.error("Ошибка при получении клиентов:", error);
      }
    },
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.currentPage = 1;
      }
    },
  }
};
</script>


<style scoped>
.profile-grid {
  display: grid;
  grid-template-columns: 150px 1fr;
  gap: 8px 16px;
  align-items: start;
  margin-top: 12px;
}
.profile-label {
  font-weight: 600;
  color: #555;
  text-align: left;
}
.profile-value {
  color: #111;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}
.profile-value input[type="checkbox"] {
  width: 20px;
  height: 20px;
  margin: 0;
  text-align: left;
}
.transfer-numbers-wrapper {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 6px 8px;
  max-height: 100px;
  overflow-y: auto;
  padding-right: 4px;
}
.transfer-number {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  padding: 4px 8px;
  border-radius: 6px;
  background: #f3f4f6;
  width: 100%;
}
.blue-dot {
  width: 6px;
  height: 6px;
  background-color: #4f46e5;
  border-radius: 50%;
  flex-shrink: 0;
}
input[type="checkbox"][disabled] {
  cursor: not-allowed;
}
.col-active {
  width: 140px;
  min-width: 140px;
  max-width: 140px;
  text-align: center;
}
.actions-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
}
.dots-btn {
  background: none;
  border: none;
  padding: 4px 6px;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  color: #4f46e5;
}
.dots-btn:hover {
  color: #4338ca;
}
.actions-popover {
  position: absolute;
  top: 50%;
  left: 100%;
  transform: translate(8px, -50%);
  background: #ffffff;
  border-radius: 10px;
  padding: 6px;
  min-width: 150px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05);
  z-index: 20;
}
.popover-btn {
  width: 100%;
  background: none;
  border: none;
  padding: 10px 12px;
  font-size: 14px;
  text-align: left;
  border-radius: 8px;
  cursor: pointer;
  color: #111827;
}
.popover-btn:hover {
  background: #f3f4f6;
}
.popover-btn.secondary {
  color: #dc2626;
}
.popover-btn.secondary:hover {
  background: #fee2e2;
}
.login-title {
  margin: 0;
  font-size: 28px;
  font-weight: 600;
  color: #4e54c8;
  text-decoration: none !important;
}
.toggle-switch {
  position: relative;
  width: 50px;
  height: 26px;
}
.toggle-switch input {
  opacity: 0;
  width: 50px;
  height: 26px;
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  margin: 0;
}
.toggle-switch .slider {
  position: absolute;
  pointer-events: none;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  border-radius: 26px;
  transition: 0.4s;
}
.toggle-switch .slider:before {
  position: absolute;
  content: "";
  height: 22px;
  width: 22px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  border-radius: 50%;
  transition: 0.4s;
}
.toggle-switch input:checked + .slider {
  background-color: #4f46e5;
}
.toggle-switch input:checked + .slider:before {
  transform: translateX(24px);
}
#reportPage {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 20px;
  background: linear-gradient(135deg, #1e3c72, #2a5298);
}
.profiles-wrapper {
  display: flex;
  justify-content: center;
  gap: 100px;
  margin-top: 20px;
}
.profile-card {
  width: 100%;
  max-width: none;
  background: #f9fafb;
  border-radius: 12px;
  padding: 60px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.12);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
}
.profile-card:hover {
  box-shadow: 0 12px 30px rgba(0,0,0,0.12);
}
.profile-header h2 {
  font-size: 20px;
  font-weight: 700;
  color: #1f2937;
}
.status-badge {
  font-size: 13px;
  padding: 4px 12px;
  border-radius: 12px;
  font-weight: 600;
  text-transform: uppercase;
}
.status-badge.active {
  background: #ecfdf5;
  color: #065f46;
}
.status-badge.inactive {
  background: #fef2f2;
  color: #7f1d1d;
}
.profile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.profile-body {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.profile-row {
  font-size: 14px;
  color: #333;
}
.profile-actions {
  position: absolute;
  top: 16px;
  right: 16px;
}
.report-card {
  width: 100%;
  max-width: none;
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}
.page-header {
  margin-bottom: 20px;
}
.title-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.page-header h1 {
  margin: 0;
  font-size: 20px;
}
.subtitle {
  margin-top: 4px;
  color: #666;
}
.table-wrapper {
  padding: 0;
}
.table {
  width: 100%;
  border-collapse: collapse;
  font-size:14px;
}
.table th, .table td {
  border: 1px solid #e5e7eb;
  padding: 10px 12px;
  vertical-align: middle;
}
.table th {
  background: #f9fafb;
  font-weight: 600;
  color: #374151;
  text-align: center;
}
.td-right {
  text-align: right;
  font-variant-numeric: tabular-nums;
}
.logout-modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  z-index: 10000;
}
.logout-modal-overlay .modal-content {
  position: absolute;
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  min-width: 200px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.2);
  animation: scaleIn 0.2s ease;
}
.td-center {
  text-align: center;
}
.table tbody tr:hover {
  background-color: #f9fafb;
}
.empty {
  text-align: center;
  padding: 20px;
  color: #9ca3af;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.modal-content {
  position: absolute;
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  max-width: 600px;
  min-width: 200px;
  width: 90%;
  box-shadow: 0 10px 25px rgba(0,0,0,0.2);
  animation: scaleIn 0.2s ease;
}
@keyframes dropdownIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.modal-form .form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 20px;
}

.modal-actions-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}
.signed-in-text {
  font-size: 14px;
  color: #888;
}
.user-name {
  font-size: 18px;
  font-weight: 700;
  color: #000;
}
.panel-action-link {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 8px;
  color: #111;
  text-decoration: none;
  cursor: pointer;
}
.panel-action-link:hover {
  background: #f3f4f6;
}
.logout-link {
  font-weight: 500;
}
.user-icon {
  position: relative;
  cursor: pointer;
}
.divider {
  height: 1px;
  background: #eee;
  margin: 12px 0;
}
/* и дальше весь CSS точно также продолжать с отступами ... */
</style>